import { actions } from 'forms/rrf';
import { toast } from 'react-toastify';
import irelandApi from '../irelandApi';
import {
  DELETE_ADMIN_MARKETING_CATEGORY_FULFILLED,
  DELETE_ADMIN_MARKETING_CATEGORY_PENDING,
  DELETE_ADMIN_MARKETING_CATEGORY_REJECTED,
  GET_ADMIN_MARKETING_CATEGORIES_FULFILLED,
  GET_ADMIN_MARKETING_CATEGORIES_PENDING,
  GET_ADMIN_MARKETING_CATEGORIES_REJECTED,
  GET_MARKETING_CATEGORIES_FULFILLED,
  GET_MARKETING_CATEGORIES_PENDING,
  GET_MARKETING_CATEGORIES_REJECTED,
  UPDATE_ADMIN_MARKETING_CATEGORIES_FULFILLED,
  UPDATE_ADMIN_MARKETING_CATEGORIES_PENDING,
  UPDATE_ADMIN_MARKETING_CATEGORIES_REJECTED
} from '../reducers/marketingCategoriesReducer';
import ToastMessage from '../components/common/toast-message';
import store from '../store';

const url = '/api/marketing_categories';
const adminUrl = '/api/admin/marketing_categories';

const loadFormData = (response) => {
  const data = {};

  response.data.data.forEach((marketingCategory) => {
    data[`name_${marketingCategory.id}`] = marketingCategory.name;
  });

  store.dispatch(actions.load('deep.admin_marketing_category', data));
};

export const getMarketingCategories = () => (dispatch) => {
  dispatch({ type: GET_MARKETING_CATEGORIES_PENDING });

  return irelandApi.get(url)
    .then((response) => {
      const marketingCategories = {};

      Object.keys(response.data).forEach((key) => {
        marketingCategories[key] = { value: true };
      });

      store.dispatch(actions.load('deep.about_you.user.marketing_categories', marketingCategories));
      dispatch({ type: GET_MARKETING_CATEGORIES_FULFILLED, payload: response.data });
    })
    .catch((error) => {
      dispatch({ type: GET_MARKETING_CATEGORIES_REJECTED, payload: error.data });
    });
};

export const getAdminMarketingCategories = () => (dispatch) => {
  dispatch({ type: GET_ADMIN_MARKETING_CATEGORIES_PENDING });

  return irelandApi.get(adminUrl)
    .then((response) => {
      loadFormData(response);
      dispatch({ type: GET_ADMIN_MARKETING_CATEGORIES_FULFILLED, payload: response.data });
    })
    .catch((error) => {
      dispatch({ type: GET_ADMIN_MARKETING_CATEGORIES_REJECTED, payload: error.data });
    });
};

export const updateAdminMarketingCategories = (payload, handleRemoveCategoryOnClick) => {
  store.dispatch({ type: UPDATE_ADMIN_MARKETING_CATEGORIES_PENDING });

  const data = {
    marketing_category: { marketing_categories: { ...payload } }
  };

  return irelandApi.patch(`${adminUrl}/upsert_marketing_categories`, data)
    .then((response) => {
      handleRemoveCategoryOnClick();
      loadFormData(response);
      store.dispatch({ type: UPDATE_ADMIN_MARKETING_CATEGORIES_FULFILLED, payload: response.data });
      toast.success(<ToastMessage iconStyle="success" message="Marketing Categories have been updated successfully" />);
    })
    .catch((error) => {
      store.dispatch({ type: UPDATE_ADMIN_MARKETING_CATEGORIES_REJECTED, payload: error.data });
    });
};

export const deleteAdminMarketingCategory = id => (dispatch) => {
  dispatch({ type: DELETE_ADMIN_MARKETING_CATEGORY_PENDING });

  return irelandApi.delete(`${adminUrl}/${id}`)
    .then((response) => {
      loadFormData(response);
      dispatch({ type: DELETE_ADMIN_MARKETING_CATEGORY_FULFILLED, payload: id });
      toast.success(<ToastMessage iconStyle="success" message="Marketing Category has been deleted successfully"/>);
    })
    .catch((error) => {
      dispatch({ type: DELETE_ADMIN_MARKETING_CATEGORY_REJECTED, payload: error.data });
    });
};
